/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EducationTranslation
 */
export interface EducationTranslation {
    /**
     * 
     * @type {string}
     * @memberof EducationTranslation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EducationTranslation
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof EducationTranslation
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof EducationTranslation
     */
    graduationYear?: number;
}

/**
 * Check if a given object implements the EducationTranslation interface.
 */
export function instanceOfEducationTranslation(value: object): value is EducationTranslation {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function EducationTranslationFromJSON(json: any): EducationTranslation {
    return EducationTranslationFromJSONTyped(json, false);
}

export function EducationTranslationFromJSONTyped(json: any, ignoreDiscriminator: boolean): EducationTranslation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'graduationYear': json['graduationYear'] == null ? undefined : json['graduationYear'],
    };
}

export function EducationTranslationToJSON(value?: EducationTranslation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'title': value['title'],
        'description': value['description'],
        'graduationYear': value['graduationYear'],
    };
}

